import React, { useState } from "react";
import bell from "../assets/svgs/bell.svg";
import chevron_bottom from "../assets/svgs/chevron_bottom.svg";
import { useNavigate } from "react-router-dom";
import logout_icon from "../assets/svgs/logout.svg";
import { useSelector } from "react-redux";
import  { Link } from "react-router-dom";
import user from '../assets/imgs/user.jpeg';

const Header = ({ handleSlideBar, handleMobileNav }) => {
  const state = useSelector((state) => state.auth?.user);
  const navigate = useNavigate();

  const [toggle, setToggle] = useState(false);

  const handleDropDown = () => {
    setToggle(prev => !prev);
  }

  const logout = () => {
      localStorage?.clear("token");
      localStorage?.clear("accessToken");
    navigate("/");
  }

  const handleProfileView = () => {
    navigate("/profile");
  }

  return (
    <div className="bg-secondary-n-10  flex justify-between items-center px-4 py-3 border-b-[1px] border-b-secondary-n-40 relative">
      {/* hamburger */}
      <div className="lg:hidden sm:block md:block block">
      <div className="hamburger flex flex-col gap-1" onClick={handleMobileNav}>
        <div className="w-8 h-[3px] bg-secondary-n-900"></div>
        <div className="w-8 h-[3px]  bg-secondary-n-900"></div>
        <div className="w-8 h-[3px]  bg-secondary-n-900"></div>
      </div>
      </div>
     <div className="lg:block hidden sm:hidden md:hidden">
     <div className="hamburger flex flex-col gap-1" onClick={handleSlideBar}>
        <div className="w-8 h-[3px] bg-secondary-n-900"></div>
        <div className="w-8 h-[3px]  bg-secondary-n-900"></div>
        <div className="w-8 h-[3px]  bg-secondary-n-900"></div>
      </div>
     </div>

      {/*  */}
      <div className="flex gap-8 items-center">
        <img src={bell} alt="bell" />
        <div>
        <div className="flex items-center gap-4">
          <div className="flex gap-2 items-center">
            <div className="flex flex-col gap-[2px]">
              {state ? (
                <h1 className="font-normal text-sm font-poppins text-secondary-n-400">
                {state?.sub}
              </h1>
              ) : (<></>)}
              
              <p className="text-end font-poppins text-xs font-normal">Admin</p>
            </div>
            {/* <div className="w-11 h-11 rounded-full bg-slate-900"></div> */}
            <div className="w-11 h-11">
              <img src={user} alt="user" height={100} width={100} className="rounded-full !w-full !h-full" />
            </div>
          </div>
          <div>
            <img src={chevron_bottom} alt="chevron down" onClick={handleDropDown} />
          </div>
        </div>
        <div className={`absolute right-6 z-10 mt-2 w-44 origin-top-right ${toggle ? "block" : "hidden"} rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none`} role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
    <div className="py-1">
      <Link to="/dashboard/profile" className="text-secondary-n-900  block px-4 py-2 text-sm hover:bg-secondary-yellow-300 hover:text-white">
        <p onClick={handleDropDown}>
        Profile
        </p>
        </Link>
      
        <button type="click" onClick={logout} className="text-secondary-n-900 block w-full px-4 py-2 text-left text-sm hover:bg-secondary-yellow-300 hover:text-white">Sign out</button>
    
    </div>
  </div>
        {/* <div className={`rounded-md p-6 w-44 h-12 bg-white absolute top-16 right-8 flex items-center justify-center ${toggle ? "block" : "hidden"}`}>
        <div className="flex items-center gap-3">
            <img src={logout_icon} alt="logout" />
          <button className="font-poppins text-sm font-normal text-primary-red-500 text-left" onClick={handleProfileView}>Profile</button>
          </div>
          <div className="flex items-center gap-3">
            <img src={logout_icon} alt="logout" />
          <button className="font-poppins text-sm font-normal text-primary-red-500 text-left" onClick={logout}>Logout</button>
          </div>
        </div> */}
        </div>
      </div>
    </div>
  );
};

export default Header;
